<!-- 审核 -->
<template>
  <div class="diseaseList">
    <!-- 封装selectForm筛选 -->
    <el-form :inline="true" class="filter-bar">
      <el-form-item label="门店ID" size="small">
        <el-input
          v-model="listQuery.store_id"
          placeholder="请输入门店ID"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="会员手机号" size="small">
        <el-input
          v-model="listQuery.phone"
          placeholder="请输入会员手机号"
          clearable
        ></el-input>
      </el-form-item>
      <el-button type="primary" @click="handleSearch" size="small" v-waves
        >搜索</el-button
      >
    </el-form>
    <div class="tableList">
      <!-- 封装表单table组件 -->
      <ElTable
        :columns="listHeader"
        :tableData="tableData"
        :loading="loading"
        :total="listQuery.total"
        header-bg-color="#F1F6FC"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
        <template slot="storeName" slot-scope="{ row }">
          <div class="store-name-cell">
            <div class="store-avatar"><i class="el-icon-user-solid"></i></div>
            <div class="store-info">
              <span class="store-name-text">{{ row.store_name }}</span>
              <span class="store-openid" v-if="row.create_user"
                >openid：{{ row.create_user }}
                <i
                  class="el-icon-document-copy copy-icon"
                  @click.stop="copyText(row.create_user)"
                ></i>
              </span>
            </div>
          </div>
        </template>
        <template slot="type" slot-scope="{ row }">
          <span class="type-chip" :class="typeClass(row.type)">{{
            row.type
          }}</span>
        </template>
        <template slot="money" slot-scope="{ row }">
          <span class="money-text">{{ row.money }}</span>
        </template>
        <template slot="msg" slot-scope="{ row }">
          <span :class="{ 'cell-empty': !row.msg }">{{ row.msg || "-" }}</span>
        </template>
      </ElTable>
    </div>
  </div>
</template>

<script>
import ElTable from "@/components/elTable/index.vue";
import listHeader from "./listHeader";
import filterQueryFormItems from "./filterQueryFormItems";
import Percentage from "@/components/filters/Percentage.vue";
import FillingStatus from "@/components/filters/FillingStatus.vue";
import KindTab from "@/components/tab/kindTab/index.vue";
import { selectVipCard } from "@/services/plus/vipCard";
export default {
  components: {
    ElTable,
    Percentage,
    FillingStatus,
    KindTab,
  },
  async created() {
    this.getListData();
  },
  data() {
    return {
      loading: false,
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
      },
      /* 表格数据 */
      tableData: [],
    };
  },
  computed: {
    filterQueryFormItems,
    listHeader,
  },
  watch: {},
  methods: {
    async getListData(listQuery) {
      this.loading = true;
      const { data, code, count } = await selectVipCard(
        listQuery || this.listQuery
      );
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 600);
      }
    },
    /* 搜索按钮 */
    async handleSearch() {
      this.listQuery.pageNumber = 1;
      this.getListData();
    },
    /* 分页 */
    handleCurrentChange(e) {
      console.log(e);
      this.listQuery.pageNumber = e;
      this.getListData();
    },
    handleSizeChange(e) {
      console.log(e);
      this.listQuery.pageSize = e;
      this.getListData();
    },

    /* 复制文本到剪贴板 */
    async copyText(text) {
      if (!text) return;
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(text);
        } else {
          /* 非 HTTPS 环境降级：临时 textarea + execCommand */
          const el = document.createElement("textarea");
          el.value = text;
          el.style.position = "fixed";
          el.style.opacity = "0";
          document.body.appendChild(el);
          el.select();
          document.execCommand("copy");
          document.body.removeChild(el);
        }
        this.$message({
          type: "success",
          message: "已复制 openid",
        });
      } catch (e) {
        this.$message({
          type: "error",
          message: "复制失败，请手动复制",
        });
      }
    },

    /* 卡种对应的标签配色 */
    typeClass(type) {
      const map = {
        储值卡: "chip-green",
        积分卡: "chip-blue",
        次卡: "chip-orange",
      };
      return map[type] || "chip-gray";
    },
  },
};
</script>

<style scoped lang="less">
.diseaseList {
  width: 100%;
}

/* 筛选区：白色圆角卡片上半部 */
.filter-bar {
  background: #fff;
  border-radius: 8px 8px 0 0;
  padding: 28px 16px 12px;
  margin: 0;

  /deep/ .el-form-item {
    margin-right: 20px;

    .el-input__inner {
      width: 180px;
    }
  }
  > .el-button--primary:last-of-type {
    background: #3d8dfc;
    border-color: #3d8dfc;
  }
}

/* 表格区：白卡下半部 */
.tableList {
  border-radius: 0 0 8px 8px;
  background: #fff;
  padding: 12px 16px 16px;

  /* 单元格不换行，超出显示省略号 */
  /deep/ .el-table .cell {
    white-space: nowrap;
  }
}

/* 店铺名称单元格：头像 + 名称 */
.store-name-cell {
  display: flex;
  align-items: center;

  .store-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #e5e6eb;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    margin-right: 10px;
    flex-shrink: 0;
  }
  /* 右侧信息：名称在上，openid 在下 */
  .store-info {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }
  .store-name-text {
    font-size: 14px;
    color: #1d2129;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .store-openid {
    display: inline-flex;
    align-items: center;
    font-size: 12px;
    color: #86909c;
    line-height: 18px;
    margin-top: 2px;
    /* 完整展示 openid，不做截断 */
    white-space: nowrap;

    /* 复制图标 */
    .copy-icon {
      margin-left: 4px;
      font-size: 12px;
      cursor: pointer;
      flex-shrink: 0;
      transition: color 0.15s ease;

      &:hover {
        color: #3d8dfc;
      }
    }
  }
}

/* 卡种标签：浅色底 + 同色文字 */
.type-chip {
  display: inline-block;
  font-size: 12px;
  line-height: 20px;
  padding: 0 10px;
  border-radius: 4px;

  &.chip-green {
    background: #e8ffea;
    color: #00b42a;
  }
  &.chip-blue {
    background: #e8f3ff;
    color: #3d8dfc;
  }
  &.chip-orange {
    background: #fff3d6;
    color: #d48806;
  }
  &.chip-gray {
    background: #f2f3f5;
    color: #86909c;
  }
}

/* 空值占位：- */
.cell-empty {
  color: #c9cdd4;
}

/* 余额：强调显示 */
.money-text {
  font-size: 14px;
  font-weight: 600;
  color: #1d2129;
}
</style>
